import { render, staticRenderFns } from "./ManagerAnalyticsList.vue?vue&type=template&id=36781de2&scoped=true"
import script from "./ManagerAnalyticsList.vue?vue&type=script&lang=js"
export * from "./ManagerAnalyticsList.vue?vue&type=script&lang=js"
import style0 from "./ManagerAnalyticsList.vue?vue&type=style&index=0&id=36781de2&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36781de2",
  null
  
)

export default component.exports